/**
 * 순공시간 데일리 리포트 설정 카드 (운영자) — 2026-06-23
 * 시설 정보 페이지. ON/OFF · 발송시각 · 푸시/알림톡 토글 + 지금 보내기(테스트).
 * 백엔드: /api/v1/owner/study-report/*
 */
import React, { useCallback, useEffect, useState } from 'react';
import { API_BASE_URL } from '../../../config/api';

const authHeader = (): Record<string, string> => {
  const t = localStorage.getItem('auth_access_token') || localStorage.getItem('accessToken') || localStorage.getItem('token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};
const api = (p: string) => `${API_BASE_URL}/api/v1/owner/study-report${p}`;

interface Settings { is_enabled: boolean; send_time: string; push_enabled: boolean; alimtalk_enabled: boolean; }

export default function StudyReportCard() {
  const [s, setS] = useState<Settings | null>(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    const res = await fetch(api('/settings'), { headers: authHeader() });
    if (res.ok) setS((await res.json()).settings);
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (!s) return;
    setBusy(true);
    try {
      const res = await fetch(api('/settings'), { method: 'PUT', headers: { 'Content-Type': 'application/json', ...authHeader() }, body: JSON.stringify(s) });
      if (res.ok) alert('순공 리포트 설정이 저장되었습니다'); else alert('저장 실패');
    } finally { setBusy(false); }
  };
  const sendNow = async () => {
    if (!window.confirm('지금 학부모에게 오늘 순공 리포트를 보낼까요? (오늘분 1회 발송)')) return;
    setBusy(true);
    try {
      const res = await fetch(api('/send-now'), { method: 'POST', headers: authHeader() });
      const d = await res.json();
      alert(res.ok ? (d.message || '발송 완료') : '발송 실패');
    } finally { setBusy(false); }
  };

  if (!s) return null;
  const box = 'bg-white shadow rounded-lg p-6 mb-6';

  return (
    <div className={box}>
      <h3 className="text-lg font-bold mb-1">📊 순공시간 데일리 리포트</h3>
      <p className="text-gray-500 text-sm mb-4">매일 설정한 시각에 학부모에게 자녀의 순공시간(오늘·이번주·이번달)을 보냅니다.</p>

      <label className="flex items-center gap-2 mb-4">
        <input type="checkbox" checked={s.is_enabled} onChange={(e) => setS({ ...s, is_enabled: e.target.checked })} />
        <span className="font-semibold">리포트 발송 켜기</span>
      </label>

      <div className="grid sm:grid-cols-2 gap-4 mb-4 max-w-lg">
        <div>
          <label className="text-xs text-gray-500 block mb-1">발송 시각</label>
          <input type="time" value={s.send_time} onChange={(e) => setS({ ...s, send_time: e.target.value })} className="w-full border rounded-lg px-3 py-2" />
          <p className="text-xs text-gray-400 mt-1">학습 종료 후 저녁 시각 권장 (예: 22:30)</p>
        </div>
        <div className="space-y-2">
          <label className="text-xs text-gray-500 block mb-1">발송 채널</label>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={s.push_enabled} onChange={(e) => setS({ ...s, push_enabled: e.target.checked })} />
            앱 푸시 알림
          </label>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={s.alimtalk_enabled} onChange={(e) => setS({ ...s, alimtalk_enabled: e.target.checked })} />
            카카오 알림톡 <span className="text-xs text-gray-400">(건당 비용)</span>
          </label>
        </div>
      </div>

      <div className="flex gap-2">
        <button onClick={save} disabled={busy} className="bg-blue-600 text-white rounded-lg px-4 py-2 font-semibold">설정 저장</button>
        <button onClick={sendNow} disabled={busy} className="border border-blue-500 text-blue-600 rounded-lg px-4 py-2 font-semibold">지금 보내기(테스트)</button>
      </div>
    </div>
  );
}
